import { FormattedMessage, FormattedNumber } from 'react-intl';

import { alpha, Box, BoxProps, Typography } from '@mui/material';

export interface LimitedOfferingDisclaimerProps extends BoxProps {
  maxSharesPerAccount: number;
  offeringName: string;
  sharePrice: number;
}

export const LimitedOfferingDisclaimer = ({
  maxSharesPerAccount,
  offeringName,
  sharePrice,
  sx,
  ...rest
}: LimitedOfferingDisclaimerProps) => {
  return (
    <Box
      py={{ xs: 2, md: 3 }}
      px={{ xs: 2, md: 4 }}
      mb={4}
      sx={{ backgroundColor: ({ palette }) => alpha(palette.info.main, 0.1), ...sx }}
      {...rest}
    >
      <Typography variant="body1.medium">
        <FormattedMessage
          id="property-details.maxInvestmentAmount"
          values={{
            offeringName,
            maxInvestment: (
              <FormattedNumber
                value={maxSharesPerAccount * sharePrice}
                maximumFractionDigits={0}
                minimumFractionDigits={0}
                style="currency"
                currency="USD"
              />
            ),
          }}
        />
      </Typography>
    </Box>
  );
};
